var map = {
	"./1-VISA-logo.png": 9854,
	"./2 - Mastercard-logo.svg.png": 4197,
	"./3 - American-Express-logo.png": 7186,
	"./4 - paynow.png": 395,
	"./z-QR.png": 1477,
	"Common/Components/AppFooter/Assets/Icons/Png/1-VISA-logo.png": 9854,
	"Common/Components/AppFooter/Assets/Icons/Png/2 - Mastercard-logo.svg.png": 4197,
	"Common/Components/AppFooter/Assets/Icons/Png/3 - American-Express-logo.png": 7186,
	"Common/Components/AppFooter/Assets/Icons/Png/4 - paynow.png": 395,
	"Common/Components/AppFooter/Assets/Icons/Png/z-QR.png": 1477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5394;